import { useQuery } from 'react-query';

import axiosInstance from '../../../../api/axiosInstance';
import query from '../../../../api/constants.api';
import { serializeIncident } from '../../../../api/helpers.api';
import { useAuthContext } from '../../../../contexts/AuthContext';

type TProps = {
    tab: number | undefined;
};

const useFetchMyIncidents = ({ tab }: TProps) => {
    const { user } = useAuthContext();

    const fetchIncidents = ({ tab }: { tab: TProps['tab'] }) => {
        let state;
        let sysparm_query = `watch_list=${user.sys_id}^ORcaller_id=${user.sys_id}`;

        if (tab === 0) state = '1';
        if (tab === 1) state = '15';
        if (tab === 2) sysparm_query = sysparm_query + `^state=2^ORstate=33^ORstate=14`; // 2,33,14
        if (tab === 3) sysparm_query = sysparm_query + `^state=6^ORstate=8^ORstate=27`; // 6, 8, 27

        const params = {
            sysparm_fields: 'sys_id,name,number,impact,short_description,sys_updated_on,opened_at,opened_by,description,u_nova_section,location,priority,business_service,u_latitude,u_longitude,state,caller_id,comments,watch_list',
            //active: true,
            sysparm_display_value: 'all',
            company: 'NOVA - Campus de Campolide',
            sysparm_query: sysparm_query,
            state: state,
        };
        return axiosInstance('GET', query.path.incident, null, params, 'application/json');
    };

    return useQuery(['getIncidents', tab], () => fetchIncidents({ tab }), {
        enabled: !!user, /*!!user?.sys_id*/
        refetchOnWindowFocus: false,
        select: (data) => serializeIncident(data?.data.result),
    });
};

export default useFetchMyIncidents;